module.exports = contentClient;